import axios from "axios";

/**
 * Create an Axios instance with common defaults.
 * @param {string} baseURL
 * @param {object} [opts]
 */
export function createHttpClient(baseURL, opts = {}) {
  return axios.create({
    baseURL,
    timeout: opts.timeout || 10000,
    ...opts,
  });
}
